// extracted by mini-css-extract-plugin
module.exports = {"header":"NavA_header__34qu8","list":"NavA_list__Ap2rK"};